import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";

export function describeRequestEnvVars(
  record: Record<string, unknown>,
): ToolActivity {
  const asked = Array.isArray(record.variables)
    ? record.variables.length
    : null;
  return labelOnly(
    asked
      ? `Requested ${asked} environment variable${asked === 1 ? "" : "s"}`
      : "Requested environment variables",
  );
}
